import { DateTime } from 'luxon';
import {
  Action,
  ACTION_TYPES,
  ActionType,
  CATEGORIES_STATUS,
  EventDate,
  RESERVATION_TYPES,
} from '../../models/action';

// only clean functions

export function isSurnameFieldRequired({
  type,
  reservation_type,
  certificate_last_name_required,
  reservation_by_name_only,
}: {
  type: ActionType;
  certificate_last_name_required: boolean;
  reservation_by_name_only: boolean;
  reservation_type: string;
}) {
  if (type === ACTION_TYPES.FREE) {
    return false;
  }
  if (type === ACTION_TYPES.certificate && certificate_last_name_required) {
    return true;
  }
  if (
    type === ACTION_TYPES.reservation &&
    !reservation_by_name_only &&
    reservation_type === RESERVATION_TYPES.full
  ) {
    return true;
  }
  return false;
}

export function isPhoneFieldRequired({ type }: { type: ActionType }) {
  // TODO а что с purchase?
  if (type === ACTION_TYPES.FREE) {
    return false;
  }
  return true;
}

export function isDateRequired({
  isCertificateTypeWithOpenDate,
  shortReservation,
}: {
  isCertificateTypeWithOpenDate: boolean;
  shortReservation: boolean;
}) {
  if (isCertificateTypeWithOpenDate || shortReservation) {
    return false;
  }
  return true;
}

export function categoriesForSelectedDate({
  selectedDate,
  time,
  eventDates,
  action,
  isCertificateTypeWithOpenDate,
}: {
  action: Action;
  selectedDate: string | null;
  time: string | null;
  isCertificateTypeWithOpenDate: boolean;
  eventDates?: EventDate[];
}) {
  if (isCertificateTypeWithOpenDate) {
    return action.event_categories.filter(
      (category) => category.status !== CATEGORIES_STATUS.CLOSE_HIDDEN
    );
  }
  if (!selectedDate || !eventDates?.length || time === '') {
    return [];
  }
  const timeFilter =
    time === null
      ? (item: EventDate) => item.time.length === 0
      : (item: EventDate) =>
          item.time.includes(DateTime.fromFormat(time, 'T').toFormat('TT'));
  const categoriesIds = eventDates
    .filter(timeFilter)
    .map((item) => item.quotas)
    .flat()
    .map((quota) => quota.category.id);
  return action.event_categories.filter((cat) =>
    categoriesIds.includes(cat.id)
  );
}

export function eventDateForCurrentDate({
  eventDates,
  time,
}: {
  eventDates?: EventDate[];
  time: string | null;
}) {
  if (!eventDates?.length) {
    return undefined;
  }
  if (eventDates.length === 1) {
    return eventDates[0];
  }
  const timeFilter =
    time === null
      ? (item: EventDate) => item.time.length === 0
      : (item: EventDate) =>
          item.time.includes(DateTime.fromFormat(time, 'T').toFormat('TT'));
  return eventDates.find(timeFilter);
}

export function quotaForSelectedDateByCategoryId(
  categoryId: number,
  currentEventDate?: EventDate
) {
  if (currentEventDate) {
    const dateQuota = currentEventDate.quotas.find(
      (quota) => quota.category.id === categoryId
    );
    if (dateQuota) {
      return { remainder: dateQuota.remainder, status: dateQuota.status };
    }
  }
  return {};
}

export const QUOTA_REMAINDER_TYPES = {
  noTickets: 'Билетов не осталось',
};
